import debug from "debug";
import plugin from '../../lib/plugin';

export const MODULE_NAME = 'app.core/modules/store-location';
export const ELEMENT_SELECTOR = '[data-store-location]';
const log = debug(MODULE_NAME);


export function exec() {
    const elements = $(ELEMENT_SELECTOR).toArray();
    if (!elements || !elements.length) { return; }
    const { StoreLocation } = require('./component');
    plugin('storeLocation', StoreLocation);
    $(elements).storeLocation();
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/store-location/index.js